import { createFileRoute, redirect } from "@tanstack/react-router";
import { discoverUsersInfiniteQueryOptions } from "~/features/discover/api";
import { DiscoverTemplate } from "~/features/discover/DiscoverTemplate";
import { isCocoplusApp } from "~/lib/applicationId";
import { cocoplusHighReviewScoreUsersQueryOptions } from "~/lib/queryOptions/discoverSections";
import { useAuthStore } from "~/stores/useAuthStore";
import { consumePendingOnboarding } from "~/utils/pendingOnboarding";

export const Route = createFileRoute("/_authenticated/discover/")({
  // 登録直後に WebView を開き直されてここに着いたら、オンボーディングへ戻す
  beforeLoad: ({ preload }) => {
    if (!preload && consumePendingOnboarding(useAuthStore.getState().userId)) {
      throw redirect({ to: "/onboarding" });
    }
  },
  // coco+ は先頭タブ（評価が高い女の子）の取得をプリフェッチする
  loader: ({ context: { queryClient } }) =>
    isCocoplusApp()
      ? queryClient.ensureQueryData(cocoplusHighReviewScoreUsersQueryOptions())
      : queryClient.ensureInfiniteQueryData(
          discoverUsersInfiniteQueryOptions(),
        ),
  component: DiscoverTemplate,
});
